export default __webpack_public_path__ + "static/media/nothing.0fff92c1.webp";